<mat-form-field appearance="outline" class="w-100 mb-2">
  <mat-label>Filter by Serial Number</mat-label>
  <input
    matInput
    (keyup)="applyFilter($event)"
    placeholder="Enter Serial Number (e.g. 26052420xwT2mFM)"
    #input
  />
  <button
    *ngIf="input.value"
    matSuffix
    mat-icon-button
    aria-label="Clear"
    (click)="input.value = ''; dataSource.filter = ''"
  >
    <mat-icon>close</mat-icon>
  </button>
  <mat-icon *ngIf="!input.value" matSuffix>search</mat-icon>
</mat-form-field>

<mat-card class="w-100">
  <mat-card-content>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <mat-card-title class="m-0">Claimed Products List</mat-card-title>
      <span class="badge bg-primary fs-6 px-3 py-2" *ngIf="!spinner">
        Total Claimed: {{ allClaimedProducts.length }}
      </span>
    </div>

    <div class="spinner text-center py-5" *ngIf="spinner">
      <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
    </div>

    <div [hidden]="spinner" class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="text-nowrap w-100" matSort>
        <!-- Serial Number Column -->
        <ng-container matColumnDef="productCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Serial Number</th>
          <td mat-cell *matCellDef="let element">
            <span class="fw-bold text-primary font-monospace">{{ element.productCode }}</span>
          </td>
        </ng-container>

        <!-- Product Name Column -->
        <ng-container matColumnDef="productName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Product</th>
          <td mat-cell *matCellDef="let element">
            <div class="fw-medium text-dark">{{ element.productName }}</div>
            <div class="text-muted small" *ngIf="element.categoryName">{{ element.categoryName }}</div>
          </td>
        </ng-container>

        <!-- Claimed Item / Part Column -->
        <ng-container matColumnDef="claimedItemName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Claimed Item</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.claimedItemName" class="badge bg-light-primary text-primary fw-semibold">
              <mat-icon class="align-middle fs-6 me-1" style="width: 16px; height: 16px;">hub</mat-icon>
              {{ element.claimedItemName }}
            </span>
            <span *ngIf="!element.claimedItemName" class="text-muted small">
              Main Unit
            </span>
          </td>
        </ng-container>

        <!-- Manufacturing Date Column -->
        <ng-container matColumnDef="mfgDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Mfg Date</th>
          <td mat-cell *matCellDef="let element">
            <span class="text-muted">{{ element.mfgDate | date : "dd/MM/yyyy" }}</span>
          </td>
        </ng-container>

        <!-- Registered Date Column -->
        <ng-container matColumnDef="registeredDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Registered Date</th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.registeredDate | date : "dd/MM/yyyy" }}</span>
          </td>
        </ng-container>

        <!-- Claim Date Column -->
        <ng-container matColumnDef="claimDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Claim Date</th>
          <td mat-cell *matCellDef="let element">
            <span class="fw-semibold text-primary">{{ element.claimDate | date : "dd/MM/yyyy" }}</span>
          </td>
        </ng-container>

        <!-- Last Eligible Date Column -->
        <ng-container matColumnDef="lastEligibleDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Eligible Date</th>
          <td mat-cell *matCellDef="let element">
            <span class="fw-medium text-danger">{{ element.lastEligibleDate | date : "dd/MM/yyyy" }}</span>
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let element">
            <span
              class="badge"
              [ngClass]="element.isEligibleAtClaimTime ? 'bg-success' : 'bg-danger'"
            >
              {{ element.isEligibleAtClaimTime ? 'Eligible' : 'Ineligible' }}
            </span>
          </td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="text-center">Action</th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <button
              mat-stroked-button
              color="primary"
              (click)="viewDetails(element)"
              aria-label="View Claim Details"
            >
              <mat-icon class="align-middle me-1">visibility</mat-icon>
              Details
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- Row shown when no matching data -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center py-4" colspan="8">
            <div class="text-muted" *ngIf="input.value">
              No claimed products found matching serial number "<strong>{{ input.value }}</strong>"
            </div>
            <div class="text-muted" *ngIf="!input.value">
              No claimed products recorded yet.
            </div>
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="[10, 25, 50, 100]"
      aria-label="Select page of claimed products"
    ></mat-paginator>
  </mat-card-content>
</mat-card>
